/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonRelayerChannelOperatorRequest = {
    channelId?: string;
    portId?: string;
    sortDirection?: BabylonRelayerChannelOperatorRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonRelayerChannelOperatorRequest {

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

